
function TimeFormat(time,type){
    if(!time) return;
    let timeFormat = '';
    if(type=='yyyymmddhhmmss' || !type){
        timeFormat = `${time.substr(0,4)}-${time.substr(4,2)}-${time.substr(6,2)} ${time.substr(8,2)}:${time.substr(10,2)}:${time.substr(12)}`;
    }else if(type=='yyyymmdd'){
        timeFormat = `${time.substr(0,4)}-${time.substr(4,2)}-${time.substr(6,2)}`;
    }else if(type == 'hhmmss'){
        timeFormat = `${time.substr(0,2)}:${time.substr(2,2)}:${time.substr(4)}`;
    }
    return timeFormat;
}

export default TimeFormat